<template>
  <div>
    <privacyPolicy :productName="'格力服务小程序'"></privacyPolicy>
  </div>
</template>

<script>
import privacyPolicy from '@/views/privacyPolicy/privacyPolicy.vue';
export default {
    components:{
        privacyPolicy
    },
    mounted(){
      document.title = "格力服务小程序";
    },
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/privacyPolicy/selfServicePrivacyPolicy.vue